import {Component, OnInit, NgZone, OnDestroy} from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {DataService} from '../../services/data.service';
import { Subscription} from 'rxjs';

am4core.useTheme(am4themes_animated);

@Component({
  selector: 'app-fraud-auto-model',
  templateUrl: './fraud-auto-model.component.html',
  styleUrls: ['./fraud-auto-model.component.scss']
})
export class FraudAutoModelComponent implements OnInit, OnDestroy {
  private chart: am4charts.PieChart;
  statesValues: any;
  refreshChart: any;
  carQuantity: any;
  observable: Subscription;
  constructor(private dataService: DataService, private zone: NgZone) {
    this.refreshChart = false;
  }

  ngOnInit() {
    this.observable = this.dataService.fraudmessage.subscribe(data => {
      this.loadData(data);
    });

  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
        this.observable.unsubscribe();
      }
    });
  }

  loadData(data) {
    this.statesValues = data['value'];
    this.refreshChart = data['remove'];
    this.carQuantity = [['28', '22', '31', '19', '19', '2', '14', '13', '11', '21', '13', '30', '2', '22']
      , ['12', '5', '23', '5', '5', '11', '3', '12', '15', '10', '17', '7', '11', '14']];
    if (this.refreshChart === true) {
      this.removeSeries();
    }
    this.loadChart();
  }

  loadChart() {
    this.chart = am4core.create('fraudautomodaldiv', am4charts.PieChart);
    this.chart.innerRadius = am4core.percent(40);
    this.chart.data = [{
      vehicle: 'Saab',
      quantity: this.carQuantity[this.statesValues][0]
    }, {
      vehicle: 'Mercedes',
      quantity: this.carQuantity[this.statesValues][1]
    }, {
      vehicle: 'Audi',
      quantity: this.carQuantity[this.statesValues][2]
    }, {
      vehicle: 'Suburu',
      quantity: this.carQuantity[this.statesValues][3]
    }, {
      vehicle: 'Volkswagon',
      quantity: this.carQuantity[this.statesValues][4]
    }, {
      vehicle: 'Honda',
      quantity: this.carQuantity[this.statesValues][5]
    }, {
      vehicle: 'Nissan',
      quantity: this.carQuantity[this.statesValues][6]
    }, {
      vehicle: 'Accura',
      quantity: this.carQuantity[this.statesValues][7]
    }, {
      vehicle: 'Jeep',
      quantity: this.carQuantity[this.statesValues][8]
    }, {
      vehicle: 'Chevrolet',
      quantity: this.carQuantity[this.statesValues][9]
    }, {
      vehicle: 'Toyota',
      quantity: this.carQuantity[this.statesValues][10]
    }, {
      vehicle: 'Bmw',
      quantity: this.carQuantity[this.statesValues][11]
    }, {
      vehicle: 'Dodge',
      quantity: this.carQuantity[this.statesValues][12]
    }, {
      vehicle: 'Ford',
      quantity: this.carQuantity[this.statesValues][13]
    }];

// Set inner radius
    this.chart.innerRadius = am4core.percent(50);

// Add and configure Series
    const pieSeries = this.chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = 'quantity';
    pieSeries.dataFields.category = 'vehicle';
    pieSeries.slices.template.stroke = am4core.color('#fff');
    pieSeries.slices.template.strokeWidth = 2;
    pieSeries.slices.template.strokeOpacity = 1;

// This creates initial animation
    pieSeries.hiddenState.properties.opacity = 1;
    pieSeries.hiddenState.properties.endAngle = -90;
    pieSeries.hiddenState.properties.startAngle = -90;

  }

  removeSeries() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
